import {ActionWithPayload} from '../../../helpers/reduxHelpers';

/*
 * Action types.
 */

export enum CommentComposerActionsEnum {
  EXPAND_COMMENT_COMPOSER = '@@metadata/commentComposer/EXPAND_COMMENT_COMPOSER',
  COLLAPSE_COMMENT_COMPOSER = '@@metadata/commentComposer/COLLAPSE_COMMENT_COMPOSER',
}

/*
 * Actions.
 */

interface CommentComposerPayload {
  commentUid: string;
}

interface ExpandCommentComposerAction extends ActionWithPayload<CommentComposerPayload> {
  type: CommentComposerActionsEnum.EXPAND_COMMENT_COMPOSER;
}

interface CollapseCommentComposerAction extends ActionWithPayload<CommentComposerPayload> {
  type: CommentComposerActionsEnum.COLLAPSE_COMMENT_COMPOSER;
}

export type CommentComposerAction = ExpandCommentComposerAction | CollapseCommentComposerAction;

/*
 * Action creators.
 */

export function expandCommentComposerAction(commentUid: string): ExpandCommentComposerAction {
  return {
    type: CommentComposerActionsEnum.EXPAND_COMMENT_COMPOSER,
    payload: {commentUid},
  };
}

export function collapseCommentComposerAction(commentUid: string): CollapseCommentComposerAction {
  return {
    type: CommentComposerActionsEnum.COLLAPSE_COMMENT_COMPOSER,
    payload: {commentUid},
  };
}
